import React, { useEffect } from 'react';
import ErrorBanner from './ErrorBanner';
import useErrorBanner from 'hooks/error-banner/useErrorBanner';

const GlobalErrorBanner = () => {
    const { banner, setBanner, emptyBanner } = useErrorBanner();

    useEffect(() => {
        emptyBanner();
    }, []);

    if (banner) {
        return <ErrorBanner banner={banner} onDismiss={() => setBanner(null)} />;
    }
};

export default GlobalErrorBanner;
